export default __webpack_public_path__ + "static/media/face-accessories.5f38befb.svg";